import { defineComponent } from "vue";

export default defineComponent({
	name: "CalendarIcon",
	render() {
		return (
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M5.33301 1.33301V3.33301"
					stroke="white"
					stroke-width="1.3"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M10.667 1.33301V3.33301"
					stroke="white"
					stroke-width="1.3"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2.33301 6.05957H13.6663"
					stroke="white"
					stroke-width="1.3"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M14 5.66634V11.333C14 13.333 13 14.6663 10.6667 14.6663H5.33333C3 14.6663 2 13.333 2 11.333V5.66634C2 3.66634 3 2.33301 5.33333 2.33301H10.6667C13 2.33301 14 3.66634 14 5.66634Z"
					stroke="white"
					stroke-width="1.3"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M7.99666 9.13314H8.00265"
					stroke="white"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M5.52987 9.13314H5.53585"
					stroke="white"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M5.52987 11.1331H5.53585"
					stroke="white"
					stroke-width="1.3"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		);
	},
});
